import CFG from '../gameLoopConfig.json';
import { WORLD_WIDTH, WORLD_HEIGHT, PLAYER_SIZE, ENEMY_DAMAGE } from '../../../constants';
import { calcDamageReceived } from '../helpers';

export function updateProjectiles(s, dt, timestamp, pcx, pcy, setGameState) {
  if (!s.projectiles || s.projectiles.length === 0) return false;
  const isShielded = timestamp < (s.shieldUntil ?? 0);

  for (let pi = s.projectiles.length - 1; pi >= 0; pi--) {
    const proj = s.projectiles[pi];
    proj.x += proj.vx * dt;
    proj.y += proj.vy * dt;

    if (timestamp - proj.spawnTime > CFG.rangedEnemy.projectileLifeMs ||
        proj.x < -30 || proj.x > WORLD_WIDTH + 30 ||
        proj.y < -30 || proj.y > WORLD_HEIGHT + 30) {
      s.projectiles.splice(pi, 1);
      continue;
    }

    const pSz = 10;
    if (!isShielded && !s.isDashing &&
        timestamp - s.lastHitTime > (s.hitCooldown ?? 1500) &&
        s.player.x < proj.x + pSz && s.player.x + PLAYER_SIZE > proj.x &&
        s.player.y < proj.y + pSz && s.player.y + PLAYER_SIZE > proj.y) {
      s.projectiles.splice(pi, 1);

      const pmod  = s.activeModifier;
      let rawHit  = Math.round((proj.damage ?? ENEMY_DAMAGE) * (pmod?.enemyDamageMult ?? 1));
      const dtype   = proj.damageType ?? 'physical';
      const fRes    = Math.max(0, Math.min(0.75, (s.fireRes ?? 0) - (pmod?.fireResDown ?? 0)));
      const lRes    = Math.max(0, Math.min(0.75, (s.lightningRes ?? 0) - (pmod?.lightningResDown ?? 0)));
      const physRes = Math.max(0, Math.min(0.75, s.resistance ?? 0));
      rawHit = calcDamageReceived(rawHit, dtype, fRes, lRes, s.armor ?? 0, physRes);

      if (s.shadowDodgeChance && Math.random() < s.shadowDodgeChance) {
        s.lastHitTime   = timestamp;
        s.lastDodgeTime = timestamp;
        s.floatingTexts.push({ id: `ft_pdg_${timestamp}_${pi}`, x: pcx, y: pcy - 20, text: '🌀 DODGE', color: '#88ccff', startTime: timestamp, duration: 900 });
        continue;
      }

      if (s.dodgeChance && Math.random() < s.dodgeChance) {
        s.lastHitTime   = timestamp;
        s.lastDodgeTime = timestamp;
        s.floatingTexts.push({ id: `ft_pdc_${timestamp}_${pi}`, x: pcx, y: pcy - 20, text: '💨 DODGE', color: '#aaffdd', startTime: timestamp, duration: 900 });
        continue;
      }

      s.hp         -= rawHit;
      s.lastHitTime = timestamp;
      s.floatingTexts.push({
        id: `ft_ph_${timestamp}_${pi}`, x: pcx, y: pcy - 20,
        text:  dtype === 'fire' ? `🔥-${rawHit}` : dtype === 'lightning' ? `⚡-${rawHit}` : `-${rawHit}`,
        color: dtype === 'fire' ? '#ff7700' : dtype === 'lightning' ? '#88ccff' : '#ffaaaa',
        startTime: timestamp, duration: 900,
      });
      if (s.hp <= 0) { s.alive = false; setGameState('dead'); return true; }
    }
  }
  return false;
}
